import { render, staticRenderFns } from "./ObjectsDrilldownView.vue?vue&type=template&id=32d354b0"
import script from "./ObjectsDrilldownView.vue?vue&type=script&lang=ts"
export * from "./ObjectsDrilldownView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports